import { render } from "./Categories.vue?vue&type=template&id=663bf59e"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"

import "./Categories.vue?vue&type=style&index=0&id=663bf59e&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__